<template>
  <div>
    <el-dialog :title="uuid ? (isRead ? '查看视频交互' : '编辑视频交互') : '添加视频交互'" :visible.sync="dialogFormVisible" width="800px">
      <el-form
        :rules="rules"
        ref="dataForm"
        :model="temp"
        label-position="left"
        label-width="110px"
        style="margin: 0 30px;"
        :disabled="isRead"
      >
          <el-form-item label="视频交互名称" prop="name">
            <el-input type="text" v-model="temp.name" maxlength="20" placeholder="请输入" show-word-limit></el-input>
          </el-form-item>
          <el-form-item label="上传视频" required>
            <el-input v-model="temp.video" readonly style="width: 200px;"></el-input>
            <el-upload
              style="display:inline-block;margin:0 20px;" 
              :action="uploadApi"
              :headers="{token}"
              :show-file-list="false"
              :on-success="handleSuccess"
              :before-upload="beforeUpload"
              v-loading="loading"
              accept="video/mp4">
              <el-button type="primary">点击上传</el-button>
            </el-upload>
            <span style="color:#949494;font-size:12px;">只能上传mp4文件，且不能超过20M</span>
          </el-form-item>
          <el-form-item label="视频时长" required>
            <el-input-number v-model="temp.duration" placeholder="请输入" :precision="3" :controls="false" :step="0.001" :min="0" /> 
            <span style="margin-left:20px;color:#949494;font-size:12px;">单位秒，精确到小数点后三位</span>
          </el-form-item>
          <el-form-item label="交互配置" required>
            <el-button @click="showAction(0)">添加交互</el-button>
          </el-form-item>
          <!-- <el-form-item label="上传视频" required>
            <img-upload class-name="miniprogram-upload" tip-size="100px 100px" v-model="temp.image" skin="small" />
          </el-form-item> -->
      </el-form>
      
      <el-table :data="temp.items" border highlight-current-row style="margin:auto; width:700px;">
        <el-table-column type="index" align="center" label="序号" width="50"></el-table-column>
        <el-table-column label="交互名称" width="240" align="center" prop="question_id" show-overflow-tooltip>
          <template slot-scope="scope">
            {{scope.row.type==2 ? '新手礼包' : actionObj[String(scope.row.question_id)]}}
          </template>
        </el-table-column>
        <el-table-column label="交互类型" width="100" align="center" prop="type">
          <template slot-scope="scope">
            {{['', '问题', '礼包'][scope.row.type]}}
          </template>
        </el-table-column>
        <el-table-column label="视频暂停时间" width="150" align="center" prop="video_point"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope" v-if="!isRead">
            <el-button type="text" size="small" @click="showAction(scope.$index+1, scope.row)">编辑</el-button>
            <el-button type="text" size="small" @click="delAction(scope.$index)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer" v-if="!isRead">
        <el-button @click="dialogFormVisible = false">取消</el-button>
        <el-button type="primary" @click="saveData">确定</el-button>
      </div>
    </el-dialog>
    <el-dialog :title="uuid ? '编辑交互' : '添加交互'" :visible.sync="formShow" width="600px">
      <el-form :model="action">
        <el-form-item label="交互类型" required>
          <el-radio-group v-model="action.type">
            <el-radio :label="1">问题</el-radio>
            <el-radio :label="2">礼包</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="交互名称" v-if="action.type==1" required>
          <el-select v-model="action.question_id" placeholder="请选择">
            <el-option
              v-for="(val, key) in actionObj"
              :key="key"
              :label="val"
              :value="Number(key)">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="视频暂停时间" v-if="action.type==1" required>
          <el-input-number v-model="action.video_point" placeholder="请输入" :precision="3" :controls="false" :step="0.001" :min="0" />
          <p style="color:#949494;font-size:12px;">视频暂停时间精确到小数点后三位，单位s，如2.124s</p>
        </el-form-item>
        <el-form-item label="运营图片" v-if="action.type==2" required>
          <img-upload class-name="miniprogram-upload" tip-size="596px 220px" v-model="action.image_url" skin="small" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="formShow = false">取消</el-button>
        <el-button type="primary" @click="saveAction">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getDetail, add, edit, questions, uploadApi } from "@/api/videoAction";
import ImgUpload from "@/components/ImgUpload";
import { getToken } from '@/utils/auth'

export default {
  name: "videoActionEdit",
  components: { ImgUpload },
  data() {
    return {
      dialogFormVisible: false,
      uuid: '',
      temp: {
        name: '',
        video: '',
        duration: 0,
        items: []
      },
      action: {
        index: 0,
        type: 1,
        question_id: '',
        image_url: '',
        video_point: ''
      },
      loading: false,
      formShow: false,
      actionObj: {},
      isRead: false,
      uploadApi,
      token: getToken(),
      rules: {
        name: [{ required: true, message: "必填项不能为空" }]
      }
    };
  },
  created() {
    questions().then(res => {
      res.data.forEach((v) => {
        this.actionObj[v.id] = v.name
      })
    })
  },
  methods: {
    // 添加
    handleCreate() {
      this.uuid = ''
      this.isRead = false
      this.temp = {
        name: '',
        video: '',
        duration: 0,
        items: []
      };
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs["dataForm"].clearValidate()
      });
    },
    // 编辑
    handleEdit(uuid, type) {
      this.uuid = uuid
      this.isRead = !!type
      getDetail(uuid).then(res => {
        Object.assign(this.temp, res.data)
        this.dialogFormVisible = true
        this.$nextTick(() => {
          this.$refs["dataForm"].clearValidate()
        });
      })
    },
    // 保存
    saveData() {
      this.$refs["dataForm"].validate(valid => {
        if (valid) {
          if(!this.temp.name.trim()) {
            return this.$message.error("请填写视频交互名称")
          }
          if (!this.temp.video) {
            return this.$message.error("请上传视频")
          }
          if(!this.temp.duration) {
            return this.$message.error("请填写视频交互时长")
          }
          if(!this.temp.items.length) {
            return this.$message.error("请添加视频交互")
          }
          let d = JSON.parse(JSON.stringify(this.temp))
          const p = this.uuid ? edit(this.uuid, d) : add(d)
          p.then(() => {
            this.$parent.fetchData()
            this.dialogFormVisible = false
            this.$parent.$notify({
              title: "成功",
              message: this.uuid ? "修改成功" : "添加成功",
              type: "success"
            });
          });
        }
      });
    },
    showAction(index, rs) {
      this.action = {
        type: 1,
        question_id: '',
        image_url: '',
        video_point: ''
      }
      if(rs) {
        Object.assign(this.action, rs)
      }
      this.action.index = index
      this.formShow = true
    },
    delAction(index) {
      this.$confirm('确认删除该交互吗？?').then(() => {
        this.temp.items.splice(index, 1)
      }).catch(() => {})
    },
    // 保存
    saveAction() {
      if(!this.action.type) {
        this.$message.error('请选择交互类型!')
        return
      }
      if(this.action.type==1 && !this.action.question_id) {
        this.$message.error('请选择交互名称!')
        return
      }
      if(this.action.type==2) {
        if(!this.action.image_url) {
          this.$message.error('请上传运营图片!')
          return
        }
        this.action.question_id = null
        this.action.video_point = 0
      }
      if(this.action.index) {
        this.$set(this.temp.items, this.action.index-1, this.action)
      } else {
        this.temp.items.push(this.action)
      }
      this.formShow = false
    },
    // 上传视频
    beforeUpload(file) {
      const isLt3M = file.size / 1024 / 1024 < 20
      if (!isLt3M) {
        this.$message.error('上传视频大小不能超过 20MB!')
      } else {
        this.loading = true
      }
      return isLt3M
    },
    handleSuccess(res) {
      this.loading = false
      if (res.code === 20000) {
        this.temp.video = res.data
      } else {
        this.$message({
          message: res.msg,
          type: 'error'
        })
      }
    }
  }
};
</script>

<style>
.miniprogram-upload .el-upload-dragger {
  width: 100px;
  height: 100px;
}
.miniprogram-upload .uploader-icon {
  margin-top: 18px;
}
</style>
